import {
  getSurveySchemaParts,
  getExtraSurveyParts,
  postSurveySchemaPart,
  postExtraSurveyPart,
  postSchemaPartVersion,
  getOrCheckSurveySchemaPartCode,
  putSurveySchemaPart,
  putExtraSurveyPart,
  postVariableExtraInfo,
  deleteVariableExtraInfo
} from '../api';
import { surveyPartTypeValues } from '../constants/types';

export const ADD_SCHEMA_PART_ITEM = 'ADD_SCHEMA_PART_ITEM';
export const ADD_VARIABLE = 'ADD_VARIABLE';
export const CLEAR_SURVEY_SCHEMA_PART_OPTIONS = 'CLEAR_SURVEY_SCHEMA_PART_OPTIONS';
export const CREATE_NEW_SCHEMA_PART_VERSION = 'POST_CREATE_NEW_SCHEMA_PART_VERSION';
export const GET_EXTRA_SURVEY_PARTS = 'GET_EXTRA_SURVEY_PARTS';
export const GET_OR_CHECK_SURVEY_SCHEMA_PART_CODE = 'GET_OR_CHECK_SURVEY_SCHEMA_PART_CODE';
export const GET_SCHEMA_PARTS = 'GET_SCHEMA_PARTS';
export const POST_SURVEY_SCHEMA_PART = 'POST_SURVEY_SCHEMA_PART';
export const PUT_SURVEY_SCHEMA_PART = 'PUT_SURVEY_SCHEMA_PART';
export const REMOVE_SCHEMA_PART_ITEM = 'REMOVE_SCHEMA_PART_ITEM';
export const REMOVE_VARIABLE = 'REMOVE_VARIABLE';
export const UPDATE_SURVEY_SCHEMA_PART_OPTIONS = 'UPDATE_SURVEY_SCHEMA_PART_OPTIONS';
export const UPDATE_SCHEMA_PART_ITEM = 'UPDATE_SCHEMA_PART_ITEM';
export const UPDATE_SCHEMA_PART_ITEM_ORDER = 'UPDATE_SCHEMA_PART_ITEM_ORDER';
export const UPDATE_VARIABLE = 'UPDATE_VARIABLE';
export const UPDATE_EXTRA_INFO = 'UPDATE_EXTRA_INFO';

export const addSchemaPartItemAction = (item) => ({
  type: ADD_SCHEMA_PART_ITEM,
  payload: item
});

export const addVariableAction = (variable) => ({
  type: ADD_VARIABLE,
  payload: variable
});

export const clearSurveySchemaPartOptionsAction = () => ({
  type: CLEAR_SURVEY_SCHEMA_PART_OPTIONS
});

export const createNewSchemaPartVersionAction = (oldSchemaPartId, options) => ({
  type: CREATE_NEW_SCHEMA_PART_VERSION,
  payload: postSchemaPartVersion(oldSchemaPartId, options)
});

export const getExtraPartsAction = (type, page, status = undefined) => ({
  type: GET_EXTRA_SURVEY_PARTS,
  payload: getExtraSurveyParts(type, page, status)
});

export const getOrCheckSurveySchemaPartCodeAction = (suggestion) => ({
  type: GET_OR_CHECK_SURVEY_SCHEMA_PART_CODE,
  payload: getOrCheckSurveySchemaPartCode(suggestion)
});

export const getSchemaPartsAction = (type, page) => ({
  type: GET_SCHEMA_PARTS,
  payload: getSurveySchemaParts({ type, page })
});

export const postSurveyPartAction = (options) => ({
  type: POST_SURVEY_SCHEMA_PART,
  payload: options.type === surveyPartTypeValues.SURVEY_SCHEMA_PART
    ? postSurveySchemaPart(options)
    : postExtraSurveyPart(options)
});

export const putSurveySchemaPartAction = (partId, options) => ({
  type: PUT_SURVEY_SCHEMA_PART,
  payload: options.surveySchemaPart.type === surveyPartTypeValues.SURVEY_SCHEMA_PART
    ? putSurveySchemaPart(partId, options)
    : putExtraSurveyPart(partId, options.surveySchemaPart)
});

export const removeSchemaPartItemAction = (index) => ({
  type: REMOVE_SCHEMA_PART_ITEM,
  payload: index
});

export const removeVariableAction = (index) => ({
  type: REMOVE_VARIABLE,
  payload: index
});

export const updateSurveySchemaPartOptionsAction = (options) => ({
  type: UPDATE_SURVEY_SCHEMA_PART_OPTIONS,
  payload: options
});

export const updateSchemaPartItemAction = (index, item) => ({
  type: UPDATE_SCHEMA_PART_ITEM,
  payload: {
    index, item
  }
});

export const updateSchemaPartItemOrderAction = (items) => ({
  type: UPDATE_SCHEMA_PART_ITEM_ORDER,
  payload: items
});

export const updateVariableAction = (index, variable) => ({
  type: UPDATE_VARIABLE,
  payload: { index, variable }
});

export const updateExtraInfoAction = (extraInfo) => ({
  type: UPDATE_EXTRA_INFO,
  payload: postVariableExtraInfo(extraInfo)
});

export const deleteExtraInfoAction = (extraInfoId) => ({
  type: UPDATE_EXTRA_INFO,
  payload: deleteVariableExtraInfo(extraInfoId)
});
